import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
export const TOKEN_NAME: string = 'jwt_token';
import { environment } from '../../environments/environment';
const AUTH_PREFIX = 'Bearer';
import { retry, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private headers;
  reqHeader: any;
  token: any;

  constructor(private httpClient: HttpClient) {
    this.initializeHeaders();
  }

  initializeHeaders() {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${AUTH_PREFIX} ${localStorage.getItem(TOKEN_NAME)}`
    });
  }

  userListing(data) {
    var page = 1;
    if (data.start == 0) {
      var page = 1;
    } else {
      var page = Math.ceil(data.start / data.length) + 1;
    }

    if (data.order[0].column == 0) {
      var column = "name";
    } else if (data.order[0].column == 1) {
      var column = "username";
    } else if (data.order[0].column == 2) {
      var column = "phone_number";
    }
    else if (data.order[0].column == 3) {
      var column = "email";
    }
    else if (data.order[0].column == 4) {
      var column = "subscription_detail.status";
    }
    else if (data.order[0].column == 5) {
      var column = "venue_subscription_detail.name";
    }
    else if (data.order[0].column == 6) {
      var column = "venue_subscription_expiration";
    }
    else {
      var column = "";
    };

    // console.log(data);
    var orderData = {};
    if (column) {
      orderData = { "column": column, "dir": data.order[0].dir };
    } else {
      orderData = "";
    };

    return this.httpClient.post<any>(`${environment.apiUrl}/admin/users`,
      { "page": page, "limit": data.length, "search_value": new String(data.search.value), "order": orderData },
      { headers: this.headers }
    ).
      pipe(catchError(this.handleError));
  }

  getUsersList() {
    return this.httpClient.get<any>(`${environment.apiUrl}/admin/export-users`,
      { "headers": this.headers }
    ).
      pipe(catchError(this.handleError));
  }

  user_detail(userId) {
    return this.httpClient.post<any>(`${environment.apiUrl}/admin/user-detail`,
      { "user_id": userId },
      { "headers": this.headers }
    ).
      pipe(catchError(this.handleError));
  }

  countData() {
    return this.httpClient.get(`${environment.apiUrl}/admin/get-count`, { headers: this.headers }).pipe(retry(1));
  }

  updateUserPromoStatus(data: any) {
    return this.httpClient.patch<any>(`${environment.apiUrl}/admin/update-promo-status`,data,{ headers: this.headers }).pipe(catchError(this.handleError));
  }

  updateUserAmbassadorStatus(data: any) {
    return this.httpClient.patch<any>(`${environment.apiUrl}/admin/update-ambassador-status`,data,{ headers: this.headers }).pipe(catchError(this.handleError));
  }

  updateHotspotSubscriptionStatus(data: any) {
    return this.httpClient.patch<any>(`${environment.apiUrl}/admin/update-user`,data,{ headers: this.headers }).pipe(catchError(this.handleError));
  }

  ambassadorListing(data: any) {
    let page = 1;
    if (data.start == 0) {
      page = 1;
    } else {
      page = Math.ceil(data.start / data.length) + 1;
    }

    let column = "";
    if (data.order[0].column == 0) {
      column = "name";
    } else if (data.order[0].column == 1) {
      column = "username";
    } else if (data.order[0].column == 2) {
      column = "phone_number";
    } else if (data.order[0].column == 3) {
      column = "email";
    } else if (data.order[0].column == 4) {
      column = "ambassadorEnabledOn";
    } else if (data.order[0].column == 5) {
      column = "referralCount";
    } else if (data.order[0].column == 6) {
      column = "isAmbassador";
    };

    let orderData = {};
    if (column) {
      orderData = { "column": column, "dir": data.order[0].dir };
    } else {
      orderData = "";
    };

    return this.httpClient.post<any>(`${environment.apiUrl}/admin/ambassadors/list`,
      { "page": page, "limit": data.length, "search_value": new String(data.search.value), "order": orderData },
      { headers: this.headers }
    ).pipe(catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    console.log(`Status:${error.status}`);
    return throwError(error);
  }
}
